import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from "@ngx-translate/core";


export interface NewFilterProfileDialogData {
  profileName: string,
}

@Component({
    selector: 'filter-profile-create-new-dialog',
    templateUrl: './filter-profile-create-new-dialog.component.html',
    styleUrls: ['./filter-profile-create-new-dialog.component.css']
})
/** tankFilterCreateNewDialog component*/
export class FilterProfileCreateNewDialogComponent  implements OnInit {
    /** FilterProfileCreateNewDialog ctor */
    constructor(
      public dialogRef: MatDialogRef<FilterProfileCreateNewDialogComponent>,
      public translate: TranslateService,
      @Inject(MAT_DIALOG_DATA) public data: NewFilterProfileDialogData
    ) {
        this.data.profileName = this.data.profileName || '';
     }

      cancel(): void {
        this.dialogRef.close(null);
      }

      save(): void {
        this.dialogRef.close(this.data);
      }

  ngOnInit(): void {
  }


}
